/**
 * error 模块封装一些错误处理的业务逻辑
 * @module error
 */

import { Dialog } from 'antd-mobile';

const DEFAULT_ERROR = { code: 'unknown_error', message: 'unknown error' };
const DEFAULT_NETWORK_ERROR_TIPS = 'Request timeout, please retry.';

function _getErrMessage (err = DEFAULT_ERROR) {
  return err.msg || err.message || 'unknown error';
}

/**
 * 是否为超时错误
 * @method isTimeoutError
 * @param {Error} err 接口错误对象
 * @return {Boolean} true-超时错误 false-非超时错误
 */
export function isTimeoutError (err) {
  const message = _getErrMessage(err);
  return message.indexOf('timeout') > -1 || message.indexOf('time out') > -1;
}

/**
 * 是否为网络错误
 * @method isNetworkError
 * @param {Error} err 接口错误对象
 * @return {Boolean} true-网络错误 false-非网络错误
 */
export function isNetworkError (err) {
  const message = _getErrMessage(err);
  return !navigator.onLine || isTimeoutError(err) || message.indexOf('Network Error') > -1 || message.indexOf('Connection interrupted') > -1;
}

/**
* 全局通用错误弹窗提示
* @method onerror
* @param {Error} err 接口错误对象
*/
function onerror (err) {
  if (err?.ignore) return; // tips：用于某些场景下的报错需要忽略 onerror 的情况

  const errTips = isNetworkError(err) ? DEFAULT_NETWORK_ERROR_TIPS : _getErrMessage(err);

  Dialog.alert({
    title: 'ERROR',
    content: errTips,
    confirmText: 'confirm'
  });
}

export default onerror;
